export default __webpack_public_path__ + "static/media/modal-success.4233434b.svg";